import { render, staticRenderFns } from "./PostalCodeField.vue?vue&type=template&id=2b13a3fc"
import script from "./PostalCodeField.vue?vue&type=script&lang=js"
export * from "./PostalCodeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports